import React from "react";
import Button from "../../../../components/Button/Button";
import StackLayout from "../../../../components/layouts/StackLayout/StackLayout";
import FieldsCollection from "../../../../components/FieldsCollection/FieldsCollection";
import EditableField from "../EditableField/EditableField";
import * as CobHelpers from "../../Cob.helpers";
import Validator from "../../../../classes/Validator";


export default class CompanySignatories extends React.Component
{
    state = {
        isCompany: this.props.session.isCompany,

        fields: {
            numberOfSignatories: 1,
            "customer_signatory_firstname_0": "",
            "customer_signatory_firstname_1": "",
            "customer_signatory_firstname_2": "",
            "customer_signatory_firstname_3": "",
            "customer_signatory_firstname_4": "",

            "customer_signatory_lastname_0": "",
            "customer_signatory_lastname_1": "",
            "customer_signatory_lastname_2": "",
            "customer_signatory_lastname_3": "",
            "customer_signatory_lastname_4": "",

            "customer_signatory_email_0": "",
            "customer_signatory_email_1": "",
            "customer_signatory_email_2": "",
            "customer_signatory_email_3": "",
            "customer_signatory_email_4": ""
        }
    };

    render()
    {
        const {state, props} = this;
        const {partner} = props;

        if (!state.isCompany)
        {
            return null;
        }

        const signatories = [];

        for (let i = 0; i < state.fields.numberOfSignatories; i++)
        {
            signatories.push(
                <FieldsCollection
                    fieldsPerRow={3}
                    key={i}
                    fields={[
                        {
                            render: (
                                <EditableField
                                    name={"customer_signatory_firstname_" + i}
                                    label="Förnamn"
                                    value={state.fields["customer_signatory_firstname_" + i]}
                                    valid={state.fields["customer_signatory_firstname_" + i].length === 0 ? null : true}
                                    onChange={this._onFieldChange}
                                    onBlur={this._onFieldBlur}
                                    style={{marginBottom: "10px"}}
                                    required={!partner._data.saveDraftButton}
                                />
                            )
                        },
                        {
                            render: (
                                <EditableField
                                    name={"customer_signatory_lastname_" + i}
                                    label="Efternamn"
                                    value={state.fields["customer_signatory_lastname_" + i]}
                                    valid={state.fields["customer_signatory_lastname_" + i].length === 0 ? null : true}
                                    onChange={this._onFieldChange}
                                    onBlur={this._onFieldBlur}
                                    style={{marginBottom: "10px"}}
                                    required={!partner._data.saveDraftButton}
                                />
                            )
                        },
                        {
                            render: (
                                <EditableField
                                    type="email"
                                    name={"customer_signatory_email_" + i}
                                    label="E-postadress"
                                    value={state.fields["customer_signatory_email_" + i]}
                                    valid={state.fields["customer_signatory_email_" + i].length === 0 ? null : Validator.validateEmail(state.fields["customer_signatory_email_" + i])}
                                    onChange={this._onFieldChange}
                                    onBlur={this._onFieldBlur}
                                    style={{marginBottom: "10px"}}
                                    required={!partner._data.saveDraftButton}
                                />
                            )
                        }
                    ]}
                />
            );
        }

        return (
            <React.Fragment>
                <h4 style={{margin: "40px 0 0 0"}}>Kontaktuppgifter firmatecknare</h4>

                <p style={{marginTop: "5px"}}>
                    Firmatecknare måste signera avtalet, vänligen ange deras kontaktuppgifter.
                </p>

                {signatories}

                <StackLayout style={{width: "60%"}}>
                    <Button
                        size="small"
                        label="Ta bort sista"
                        appearance={signatories.length <= 1 ? "medium" : "danger"}
                        disabled={signatories.length <= 1}
                        onClick={() => CobHelpers.onViewFieldChange.call(this, "numberOfSignatories", state.fields.numberOfSignatories - 1, null, () =>
                        {
                            this.props.onChange(this._areSignatoryFieldsValid());
                        })}
                    />

                    <Button
                        size="small"
                        label="Lägg till firmatecknare"
                        appearance={signatories.length >= 5 ? "medium" : "primary"}
                        disabled={signatories.length >= 5}
                        onClick={() => CobHelpers.onViewFieldChange.call(this, "numberOfSignatories", state.fields.numberOfSignatories + 1, null, () =>
                        {
                            this.props.onChange(this._areSignatoryFieldsValid());
                        })}
                        filled
                    />
                </StackLayout>
            </React.Fragment>
        );
    }

    _onFieldChange = (name, value) => {
        CobHelpers.onViewFieldChange.call(this, name, value, null, () =>
        {
            this.props.onChange(this._areSignatoryFieldsValid());
        });
    };

    _onFieldBlur = (name) => {
        CobHelpers.onViewFieldBlur.call(this, name);
    };

    // Internal methods
    _fieldValidator = (name, value) =>
    {
        return value.length > 0;
    };

    _areSignatoryFieldsValid = () =>
    {
        const {state} = this;
        if (!state.isCompany)
        {
            return true;
        }

        for (let i = 0; i < state.fields.numberOfSignatories; i++)
        {
            if (state.fields["customer_signatory_firstname_" + i].length <= 0)
            {
                return false;
            }

            if (state.fields["customer_signatory_lastname_" + i].length <= 0)
            {
                return false;
            }

            if (state.fields["customer_signatory_email_" + i].length <= 0 ||
                !Validator.validateEmail(state.fields["customer_signatory_email_" + i]))
            {
                return false;
            }
        }

        return true;
    }
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/CompanySignatories/CompanySignatories.js